import React from 'react';

export default function LabelContent({ children, paddingTop }) {
	return <div style={{ paddingTop }}>
		{children}
	</div>;
}
